export default __webpack_public_path__ + "static/media/Chrome.7c938a9d.svg";